module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAMAAADW3miqAAAADFBMVEUAAAB3d3d3d3d4eHhmlkU9AAAAA3RSTlMAgEC3KR0FAAAAKklEQVR42u3KsQEAIAwCMID/f9YLVNuOZA4miWfCRp8xKSkpaT6JZ8KTBcrYC8jkpdoBAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/paramIcon/实心正方形.png
// module id = 2aMG
// module chunks = 2